/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
define(['services/utils'], function(Utils) {
    'use strict';

    function newFeature(route, isMultiLineString) {
        return {
            type: 'Feature',
            geometry: {type: isMultiLineString ? 'MultiLineString' : 'LineString', coordinates: []},
            properties: {summary: route.summary, sections: route.sections, segmentSummary: []}
        };
    }

    function newFeatureCollection() {
        return {
            type: 'FeatureCollection',
            features: []
        };
    }

    function getCoordinates(points) {
        var coordinates = [];
        var i;
        for (i = 0; i < points.length; i += 1) {
            coordinates.push([points[i].longitude, points[i].latitude]);
        }
        return coordinates;
    }

    function getRouteFeature(route) {
        var isMultiLineString = route.legs.length > 1;
        var feature = newFeature(route, isMultiLineString);
        var i;
        for (i = 0; i < route.legs.length; i += 1) {
            feature.properties.segmentSummary.push(route.legs[i].summary);
            if (isMultiLineString) {
                feature.geometry.coordinates.push(getCoordinates(route.legs[i].points));
            } else {
                feature.geometry.coordinates = getCoordinates(route.legs[i].points);
            }
        }
        if (route.guidance) {
            feature.properties.guidance = route.guidance;
        }
        return feature;
    }

    return function(data) {
        var result, i;
        if (Utils.isString(data)) {
            try {
                data = JSON.parse(data); // aja js has problems and response is not always parsed as it should
            } catch (e) {
                return null;
            }
        }
        if (data.error) {
            return { error: data.error};
        } else {
            result = newFeatureCollection();
            result.optimizedWaypoints = data.optimizedWaypoints;
            if (!data || !data.routes) {
                return result;
            }
            for (i = 0; i < data.routes.length; i += 1) {
                result.features.push(getRouteFeature(data.routes[i]));
            }
            return result;
        }
    };
});



// WEBPACK FOOTER //
// ./model/routing/routing.js